import React from 'react'

const Manual_configuracion_imagenes_equipos_doble_pantalla = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Configuración - Imágenes Equipos Doble Pantalla
        </h2>
        <iframe
          src="https://scribehow.com/embed/Configuracion__Imagenes_Equipos_Doble_Pantalla__3rSiYfKqSmarcx9YDDeK4A?as=scrollable"
          className="scribe-iframe-general-168"
          width="100%"
          height="3800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configuracion_imagenes_equipos_doble_pantalla
